<template>
    <div :class="'graphStat-wrapper-'+statusData" v-if="statusData == 'department'" >
        <div >
            <h2 class="d-inline-block" style="position: relative;">By Department</h2>
             <div class="department-stats-bar" :style="{backgroundColor: statusColor}"></div>
                     <span class="stats-trending"><!-- TODAY --></span>
            </div>
        <div style="position: relative; height:100%; width:100%"  v-if="loadData.allDeliverables == ''">
            Media Calls by Department will be displayed.
        </div>
         <div style="position: relative; height:100%; width:100%"  v-else>
        <Bar
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :key="'barchart'+statKey"
        />
        </div>
    </div>
     <div :class="'row graphStat-wrapper-'+statusData"  v-else>
        <div class=" stats-border breakpoint__fix">
            <div class="dashboard-stats">
                <div class="stats-left-name-wrap" >
                    <span class="stats-left-name"> Trending</span>
                </div>

                <span class="stats-trending-wrap" v-if="loadData.allDeliverables == '' ">
                    <span class="stats-trending">
                        Trending tags will be displayed.
                       </span>
                     <div v-if="false" class="trending-stats-bar" :style="{backgroundColor: statusColor}"></div>
                     <span v-if="false"  class="trending-stats-bar-text"></span>

                </span>
                <span class="stats-trending-wrap" :key="'stat'+statKey" v-else>
                    <span class="stats-trending" v-for="(item, index) in trendingList.slice(0,3) " :key="index" >
                        <template v-if="index > 0 && trendingList.length > 1">, </template>{{item.name}}</span>
                     <div v-if="false" class="trending-stats-bar" :style="{backgroundColor: statusColor}"></div>
                     <span v-if="false" class="trending-stats-bar-text"></span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { Bar } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


export default {
  components: { Bar
  },
  props: {
    statusData: {
      type: String,
      default: ''
    },
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 290
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {
      	position: 'relative'
      }
    },
    plugins: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    	statKey:0,
    	maxDays:14,
    	addHoursToUTC:6,
        statusColor:"#4C9850",
        trendingList : [],
        chartData: {
        },
        chartOptions: {
            height: '10px',
            barThickness: 10,
            indexAxis: "y",
            responsive: true,
            plugins: {
                legend: {
                display: false
                },
                layout: {
                autoPadding: false
                }
            },

        },
      statusCounter: 0,
      statusName: "",
        filterQuery: {
                sort: "",
                query: "",
                filterByDate: false,
                filterByTaskDate: false,
                dateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                taskDateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                dateCompletedRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                filterByDateCreated : false,
                dateCreatedRange : {"startDate":"2022-08-11T05:00:00.942Z","endDate":"2022-08-12T05:00:00.942Z"},
                status: [{name: "Awaiting Approval", color: "#FFA500"},{name: "In Progress", color: "#8A2BE2"},{name: "Pending Completion", color: "#483D8B"} ],
                outlet: [],
                deliverableType: [],
                tag: [],
                department: [],
                coordinator: [],
                project: [],
                noDepartment: "not_accepted",
                noOutlet: "not_accepted",
                pageCount:100,
                weekFilterOptions: {
                    overdue: false,
                    today: false,
                    thisWeek: false,
                    nextWeek: false,
                    upcoming: false,
                    noDeadline: false,
                },
                 dashboardType: 'graphTrand',
            },

            loadData: {},
    };
  },
  computed: {
    ...mapGetters([

    ]),


  },

  async mounted() {
      // console.log("props : statusData", this.statusData)
  		await this.reload();

  		this.timer = setInterval(this.reload, 10000);

        this.trendingList = this.getWords();

       this.chartData ={
             labels: this.getLabels(),
           datasets:  [this.getDatasets() ],

       }
       this.chartOptions = {
            height: '30px',
            barThickness: 20,
            indexAxis: "y",
            responsive: true,
             scales: {
                    x: {
                    display: true,
                    // max: 4999,
                    stacked: true,
                    ticks: {
                    	precision: 0,
                        padding: 0.1,
                        //  stepSize: 60,
                        // min: 10,
                        // max: 20,
                        beginAtZero: true,
                    },
                    },
            y: {
                    display: true,
                    stacked: false,
                    ticks: {
                    	precision: 0,
                        padding: 1,
                        // stepSize: 40,
                        // min: 10,
                        // max: 600,
                        beginAtZero: true,
                    },
                    },
          },
                plugins: {
                    legend: {
                        display: false
                    },
                    layout: {
                        autoPadding: false
                    },
                    scales: {
                        y: [{
                            ticks: {
                            	precision: 0,
                                beginAtZero: true
                            },
                            gridLines: {
                                display: false
                            }
                        }],
                        x: [{
                            gridLines: {
                                display: false
                            }
                        }]
                    },
             },
        },
    Echo.channel('task').listen('TaskUpdated', (e) => {
        this.reload();
    });
  },
  methods: {
      ...mapActions([
			"fetchNumberStat",
		]),

    getDatasets (){
        return {
            data:  this.getData() ,
            backgroundColor: "#4C9850",
        };
    },
    getWords (){
        let t = []
        this.loadData.allDeliverables.map((item, index) => {
        t.push(
            {
            name:item.title.replace("SD -",""),
            value:item.deliverable_count,
            })
        }
      );

    return t;
    },

    getLabels (){
      return this.loadData.allDeliverables.map((item, index) =>
        this.createLabels(item, index)
      );
    },
     getData(){
      return this.loadData.allDeliverables.map((item, index) =>
        this.createData(item, index)
      );
    },
    createLabels (item, index){
      	// return  item.title;
    	// if (item.title == "Natural Resources and Northern Development") {
    	// 	item.title = "Natural Resources and<br/>Northern Development";
    	// }
    	// if (item.title == "Natural Resources and Northern Development") {
    	// 	item.title = "Natural Resources and<br/>Northern Development";
    	// }


    	 var i = 0
    	 var splitlabels = [];
    	 var words = item.title.trim().split(' and ');
    	 // console.log(item.title);
    	 // console.log(words);
    	 if(words.length >1){
    	 	splitlabels.push(""+words[0]);
    	   for(var j=1; j<words.length; j++){
    	   	splitlabels.push(" and "+words[j]);
    	   }
    	}  else {
    		return [item.title];
    	}

      return  splitlabels;
    },
    createData (item, index){
      return  item.deliverable_count;
    },

    async reload(){
        if ( this.statusData == "trending"){
            this.filterQuery.dashboardType ="graphTrending"
         }else{
             this.filterQuery.dashboardType ="graphDepartment"
         }

         let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
         let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
         this.filterQuery.dateCreatedRange.startDate = fromDate.format();
         this.filterQuery.dateCreatedRange.endDate = endDate.format();
         this.filterQuery.filterByDateCreated = true;
         this.filterQuery.deliverableType = [];
         this.filterQuery.deliverableType.push(
         {
         	"id": "media_call",
         	"name": "Media Call",
         	"typeIcon": "media-call",
         	"typeId": 1
         }
         );


       this.$store.commit("setDashboardMediaCallsFilter", this.filterQuery);
       let data = await this.$store.dispatch("fetchPublicDeliverablesGraph")


       if (JSON.stringify(data) === JSON.stringify(this.loadData)) {
           	// we're all good.
           	// console.log("same graph data");
       } else {
           	// console.log("different graph data");
   	        // that.dashboardDeliverables = that.allDeliverables;
   	        this.loadData = _.cloneDeep(data)
   	        this.statKey++;
   	    }

       // this.loadData = data;
       // this.statKey++;

       if (this.statKey >= 10) {
       	this.statKey = 0;
       }

       this.trendingList = this.getWords();
       this.chartData ={
             labels: this.getLabels(),
           datasets:  [this.getDatasets() ],
       }

	},

  }
};
</script>

<style>
</style>
